module.exports = __webpack_public_path__ + "img/all-5.97db91d5.png";